import { useQuery } from "@tanstack/react-query";
import { pricingApi } from "@/services/pricing";
import { PageShell, EmptyState, LoadingState } from "@/shared/ui/PageHeader";

export function B2BOverridesPage() {
  const overrides = useQuery({ queryKey: ["pricing", "overrides"], queryFn: pricingApi.listOverrides });
  if (overrides.isLoading) return <LoadingState />;
  const data = overrides.data ?? [];
  return (
    <PageShell title="B2B 专属价" subtitle="D2A · 客户专属折扣 / 产品专属价（覆盖 channel markup）">
      {data.length === 0 ? (
        <EmptyState message="暂无 B2B 专属价 · 在客户详情页创建" />
      ) : (
        <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
          <table className="w-full text-[13px]">
            <thead className="bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
              <tr>
                <th className="px-4 py-3 text-left">客户</th>
                <th className="px-4 py-3 text-left">产品</th>
                <th className="px-4 py-3 text-right">override %</th>
                <th className="px-4 py-3 text-left">备注</th>
                <th className="px-4 py-3 text-left">生效</th>
              </tr>
            </thead>
            <tbody>
              {data.map((o) => (
                <tr key={o.id} className="border-t border-slate-100">
                  <td className="px-4 py-3 font-medium">{o.partner_name}</td>
                  <td className="px-4 py-3 text-slate-600">{o.product_name ?? "（全部）"}</td>
                  <td className="px-4 py-3 text-right font-bold">{o.override_pct}%</td>
                  <td className="px-4 py-3 text-slate-500">{o.note ?? "—"}</td>
                  <td className="px-4 py-3 text-[11px] text-slate-500">
                    {new Date(o.effective_at).toLocaleDateString("zh-CN")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </PageShell>
  );
}
